import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type TLoadMoreProps = {
    isLoading: boolean;
    isChecking: boolean;
    loadMore: () => void;
    className?: string;
};
export default ({isLoading, isChecking, loadMore, className}: TLoadMoreProps) => {
    const onClick = () => {
        if (!isLoading) {
            loadMore();
        }
    };

    return (
        <div
            className={classNames(
                styles.loadMore,
                isLoading && styles.isLoading,
                !isLoading && isChecking && styles.isChecking,
                className,
            )}
            onClick={onClick}
        >
            <div className={styles.icon}></div>
            {
                isLoading
                    ? 'Wird geladen ...'
                    : isChecking
                        ? 'Prüfe ...'
                        : 'Mehr anzeigen'
            }

        </div>
    );
}
